import React from 'react';
const BrandsTrustUs = () => {
  const brands = [{
    name: 'Carrefour',
    logo: ''
  }, {
    name: 'Naivas',
    logo: ''
  }, {
    name: 'Chandarana',
    logo: ''
  }, {
    name: 'Samsung',
    logo: ''
  }, {
    name: 'LG',
    logo: ''
  }, {
    name: 'Dominos Pizza',
    logo: ''
  }, {
    name: 'Pizza Inn',
    logo: ''
  }, {
    name: 'Kingsway Tyres',
    logo: ''
  }, {
    name: 'Quickmart',
    logo: ''
  }];
  return <div className="py-8 border-t border-gray-200" data-id="element-55">
      <div className="max-w-4xl mx-auto px-4" data-id="element-56">
        <h2 className="text-xl font-bold text-center mb-6" data-id="element-57">
          Trusted By Leading Brands
        </h2>
        <div className="grid grid-cols-3 md:grid-cols-5 gap-6" data-id="element-58">
          {brands.map((brand, index) => <div key={index} className="flex flex-col items-center" data-id="element-59">
              <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center border border-dashed border-gray-400 mb-2" data-id="element-60">
                <span className="text-gray-500" data-id="element-61">{brand.name.charAt(0)}</span>
              </div>
              <span className="text-xs text-center" data-id="element-62">{brand.name}</span>
            </div>)}
        </div>
      </div>
    </div>;
};
export default BrandsTrustUs;